const NAVISION_MODULE_WINDOW_IDENTIFIER = Object.freeze({
    IMPORT_MODULE_WINDOW_ID: 'navisionimport',
    EXPORT_MODULE_WINDOW_ID: 'navisionexport'
});

export { NAVISION_MODULE_WINDOW_IDENTIFIER };

export default {
    NAVISION_GROUP_WRAPPER: {
        type: 'group',
        id: 'navision',
        label: "Navision",
        children: [],
        // icon: TODO: ??,
        sidebarIcon: '$wNavNavision'
    },
    CHILDREN: {
        IMPORT_MODULE: {
            type: 'module',
            id: 'navisionImport',
            windowIdentifierType: NAVISION_MODULE_WINDOW_IDENTIFIER.IMPORT_MODULE_WINDOW_ID,
            label: "Navision Import",
            // navigationImg: TODO
            routerLink: '/navisionimport',
            globalSearch: {
                index: 'navisionimport',
            }
        },
        EXPORT_MODULE: {
            type: 'module',
            id: 'navisionExport',
            windowIdentifierType: NAVISION_MODULE_WINDOW_IDENTIFIER.EXPORT_MODULE_WINDOW_ID,
            label: "Navision Export",
            // navigationImg: TODO 
            routerLink: '/navisionexport',
            globalSearch: {
                index: 'navisionexport',
            }
        }
    }
}